import { defineStore } from 'pinia';
import { base64Decode } from '@/utils/tool';

// 第一个参数是应用程序中 store 的唯一 id
export const useUserStore = defineStore('user', {
  // 其它配置项
  state: () => {
    return {
      sig: null,
      sig_t: null,
      showLogin: false
    };
  },
  getters: {
    account(state) {
      let user = null;
      try {
        if (state.sig_t && Date.now() - state.sig_t < 604800000) {
          user = JSON.parse(base64Decode(state.sig));
        } else {
          state.sig = null;
        }
      } catch (ex) {
        // state.sig=null,
      }
      return user;
    }
  },
  // 使用该插件，开启数据缓存
  persist: {
    //这里存储默认使用的是session
    enabled: true,
    strategies: [
      {
        //key的名称
        key: 'sig',
        //更改默认存储，我更改为localStorage
        storage: localStorage,
        // 可以选择哪些进入local存储，这样就不用全部都进去存储了
        // 默认是全部进去存储
        paths: ['sig']
      },
      {
        key: 'sig_t',
        storage: localStorage,
        paths: ['sig_t']
      }
    ]
  }
});
